export default "__VITE_ASSET__DPSsKS8O__"